module.exports = __webpack_public_path__ + "static/img/collectionpages.4c88e26a.jpg";